export default {
  whiteColor: '#ffffff',
  blackColor: '#000000',
  primaryColor: '#0d4175',
  // The UI currently expects secondaryColor to be transparent.
  // Setting the value from style guide will expose bugs.
  secondaryColor: 'rgba(0, 0, 0, 0)',
  primaryColorMuted: 'rgba(13, 65, 117, 0.4)',
  primaryLighterColor: '#0d4175', // used in MUI theme
  primaryDarkerColor: '#0d4175', // used in MUI theme
  primaryTextColor: '#3F3F3F',
  headingTextColor: '#878787',
  contrastTextColor: '#ffffff', // used in MUI theme
  disabledTextColor: '#A0A0A0',
  borderColor: '#BFBFBF',
  iconBorderColor: '#333333',
  shadowColor: 'rgba(0, 0, 0, 0.12)',
  successColor: '#34A33C',
  warningColor: '#FF7900',
  errorColor: '#DD0035',
  cancelColor: '#000000'
}



// WEBPACK FOOTER //
// ./src/theme/colors/palette.js